import { terrainMap } from './TerrainMap';

const PF = require('pathfinding');

export function ProcessPath(coordinates, xAdjuster, yAdjuster){
    //i = 0 is starting point
 
    const realCoordinates = []
    for (let i = 0; i < coordinates.length; i++) {
      //to move to
     
      const x = coordinates[i].x
      const y = coordinates[i].y
      const realCoord = {x:(xAdjuster + (50 * x) - (50 * y)), y:(yAdjuster + (25 * x)+ (25 * y))}
      realCoordinates.push(realCoord)
      
    }
    return realCoordinates
  }

  export function ProcessShortestPath(coordinates, xAdjuster, yAdjuster){
    //i = 0 is starting point
 
    const realCoordinates = []
    for (let i = 0; i < coordinates.length; i++) {
      //to move to
     
      const x = coordinates[i][0]
      const y = coordinates[i][1]
      const realCoord = {x:(xAdjuster + (50 * x) - (50 * y)), y:(yAdjuster + (25 * x)+ (25 * y))}
      realCoordinates.push(realCoord)
      
    }
    return realCoordinates
  }

  export function FindShortestPathPath(start, end, xAdjuster, yAdjuster){
    

    const grid = new PF.Grid(terrainMap[0].length, terrainMap.length); 
    

    for (let i = 0; i < terrainMap.length; i++) {
      for (let j = 0; j < terrainMap[i].length; j++) {
        if(terrainMap[i][j] === "r"){
          grid.setWalkableAt(j, i, true);
        }
        else{
          grid.setWalkableAt(j, i, false);
        }
       
      }
    }

    const finder = new PF.AStarFinder();
    const path = finder.findPath(start.x, start.y, end.x, end.y, grid); 
   

    const realCoordinates =  ProcessShortestPath(path, xAdjuster, yAdjuster);
    // console.log("logging shortestPath")
      
   
    return realCoordinates;
  }
 